<template>
  <!--我的账单-->
  <div class="page-box">
    <h4 class="page-box__title">我的账单</h4>
    <el-form class=""
             :model="searchData"
             ref="searchForm"
             label-width="100px"
             :inline="true"
             @submit.native.prevent>
      <el-form-item label="运单号">
        <el-input v-model="searchData.nos"
                  size="mini"
                  class="edit-form__input"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="账单号">
        <el-input v-model="searchData.billnumber"
                  size="mini"
                  class="edit-form__input"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="对账日期：">
        <el-date-picker placeholder="请选择"
                        class="edit-form__input"
                        size="mini"
                        v-model="searchData.billCheckTime"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <br/>
      <el-form-item label="账期">
        <el-date-picker v-model="startDateValue"
                        @change="changeStartDateValue"
                        size="mini"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder=""
                        end-placeholder=""
                        clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="账期产生时间">
        <el-date-picker v-model="generateDateValue"
                        @change="changeGenerateDateValue"
                        size="mini"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder=""
                        end-placeholder=""
                        clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label=" " label-width="10px">
        <el-button type="primary"
                   icon="el-icon-search"
                   @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <div class=""
         style="margin: 15px auto;">
      <el-button type="danger"
                 @click="clickCancelBillBatch"
                 :disabled="tableDataSelectValue.length<1">取消生成账单</el-button>
      <el-button type=""
                 style="margin-left: 20px;"
                 @click="downloadExcel"
                 :disabled="tableDataSelectValue.length<1">导出</el-button>
    </div>
    <el-table :data="tableData"
              @selection-change="selectionChangeValue"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              size="mini"
              highlight-current-row
              style="width: 100%;"
              border>
      <el-table-column label=""
                       type="selection"
                       width="40"></el-table-column>
      <el-table-column label="账单号"
                       align="center"
                       min-width="150"
                       prop="billnumber"></el-table-column>
      <el-table-column label="账单金额"
                       align="center"
                       width="130"
                       prop="sumamount">
        <template slot-scope="scope">
          {{scope.row.sumamount||''}} {{scope.row.currency||''}}
        </template>
      </el-table-column>
      <el-table-column label="对账日期"
                       align="center"
                       width="110"
                       prop="billCheckTime"></el-table-column>
      <el-table-column label="账期"
                       align="center"
                       min-width="130"
                       prop="paymentdays"></el-table-column>
      <el-table-column label="账单产生时间"
                       align="center"
                       min-width="130"
                       prop="billnumberTime"></el-table-column>
      <el-table-column label="操作"
                       min-width="160"
                       fixed="right"
                       align="left">
        <template slot-scope="scope">
          <div class="table-button-plain open-hover"
               @click="viewDetails(scope.row.id,scope.row)">查看详情</div>
          <div class="table-button-plain color-danger open-hover"
               @click="clickCancelBill(scope.row.id,scope.row)">取消生成账单</div>
        </template>
      </el-table-column>
    </el-table>
    <!--<el-pagination class="paging-row"-->
                   <!--background-->
                   <!--@size-change="handleSizeChange"-->
                   <!--@current-change="handleCurrentChange"-->
                   <!--:current-page="currentPage"-->
                   <!--:page-sizes="[5,10,15, 20]"-->
                   <!--:page-size="pageSize"-->
                   <!--layout="total, sizes, prev, pager, next, jumper"-->
                   <!--:total="totalListNum">-->
    <!--</el-pagination>-->
    <div class="download-box"></div>
  </div>
</template>

<script>
  import {disposeSearchData,downloadExcel} from "@/assets/js/utils";
  import {pagingMixins} from "@/assets/js/pagingMixins";
  export default {
    name: "myBill",
    mixins: [pagingMixins],
    data(){
      return {
        loading:false,
        /* 筛选 */
        searchData:{
          begintime: '',// 账单产生时间
          billCheckTime: '', // 对账日期
          billdateEnd: '', // 账单至
          billdateStart: '', // 账单从
          billnumber: '', // 账单号
          endtime: '', // 账单至时间
          nos: '', // 运单号
        },
        /* 选择框 数据 */
        startDateValue:[], //
        generateDateValue:[], // 账期产生时间
      }
    },
    created() {
      this.getList();
    },
    methods:{
      /**
       * 获取 列表
       */
      getList() {
        let data = this.jointSearchData();
        this.loading = true;
        return new Promise((resolve, reject) => {
          this.axios.post('/arapcost/getMyBillList', data)
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.tableData = [];
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.tableData = res.data.datas;
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
              this.tableData = [];
            });
        })
      },

      /**
       *  其他
       */
      /*查询时间*/
      changeStartDateValue(value){
        if(!value) value = [];
        this.searchData.billdateStart = value[0];
        this.searchData.billdateEnd = value[1];
      },
      changeGenerateDateValue(value){
        if(!value) value = [];
        this.searchData.begintime = value[0];
        this.searchData.endtime = value[1];
      },
      /*合并取消账单*/
      clickCancelBillBatch(){
        let ids = this.tableDataSelectValue.map(res=>res.id);
        if(ids.length<=0) return this.$message.error('至少选择一条数据');
        this.$confirm('此操作将取消选中的费用项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass:'el-button--danger',
          type: 'info'
        }).then(() => {
          this.cancelBill(this.selectValueIds);
        }).catch(()=>{

        });
      },
      /*取消账单*/
      clickCancelBill(id,row){
        this.$confirm('此操作将取消当前的费用项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass:'el-button--danger',
          type: 'info'
        }).then(() => {
          this.cancelBill([row.billnumber]);
        }).catch(()=>{

        });
      },
      /**
       * 取消账单
       * @param status {string} 费用状态Y：确认 LR：拒绝
       */
      cancelBill(id=[]){
        if(!Array.isArray(id)) return false;
        if(!id.length) return false;
        let data = {
          billnumbers:id,
        };
        return new Promise((resolve, reject) => {
          this.loading = true;
          this.axios.post('/arapcost/updateCancelBillById',data,{
            headers:{"Content-Type":"application/json",},
          })
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.getList();
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
            });
        })
      },
      viewDetails(id,row){
        this.$router.push({name:'myBillDetails',query:{id:row.billnumber}});
      },
      downloadExcel(){
        document.cookie="token=" + JSON.parse(localStorage.getItem("Authorization_lineSupplier")).token;
        let url = 'api';
        url += '/arapcost/getInBillLabel/';
        url += encodeURIComponent(this.selectValueIds.join(','));
        downloadExcel(url);
      },
    },
    computed:{
      /**
       * 勾选项 账单号[]
       */
      selectValueIds(){
        return this.tableDataSelectValue.map(res=>res.billnumber);
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/financialManagement/myBill.vue